import camelcase from 'camelcase'
import { UseFormRegister, FieldErrors } from 'react-hook-form'
import { Dropdown } from './forms/Dropdown'

export interface SelectInputData {
  label: string
  dataLabel: string
  required?: boolean
  register: UseFormRegister<{ [key: string]: string }>
  options: { label: string, value: string }[]
  errors: FieldErrors<any>
}

export function SelectInput({ label, register, dataLabel, required, errors, options }: SelectInputData) {

  const id = dataLabel || camelcase(label)

  const registerReturn = register(id, {
    required: required ? `${label} is required` : false,
  })

  return (
    /* Need to put select component in here */
    <Dropdown
      id={id}
      label={label}
      placeholder={label}
      register={registerReturn}
      className="col-span-2"
      defaultValue=""
      hideLabel
      errorMessage={errors?.[id]?.message}
    >
      <option value="" disabled hidden>
        {label}
      </option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Dropdown>
  )
}
